import AmpleHireModal from "../ample-hire-modal";
import styles from './style.module.css'

const NotificationMsgDetails = ({
    content,
}) => {

    return (
        <AmpleHireModal
            divTagClasses={`ampleHireModal ${styles['notification-msg-content-details']}`}
            id="notificationMsgDetailsModal"
            modalId={"notificationMsgDetailsModal"}
        >
            {content &&
                <div
                    className={`media-file-preview ${styles['notification-msg-details-modal']}`}
                    dangerouslySetInnerHTML={{
                        __html: (content),
                    }}
                />
            }
        </AmpleHireModal>
    );
};

export default NotificationMsgDetails;